import { useStorageState } from 'react-simplikit';

export function useWorkspaceCreationStorageState() {
  return useStorageState<{
    workspaceName: string;
    language: string;
  }>('workspaceCreation', {
    defaultValue: {
      workspaceName: '',
      language: '',
    },
  });
}
